import { z } from "zod";

// Update a source. `active` stays bare .optional() (never null — house rule). Bounds mirror V003.
export const updateProductSourceRequestSchema = z.object({
  code: z.string().min(1).max(50).nullable().optional(),
  name: z.string().min(1).max(200).nullable().optional(),
  tracking_config: z.string().nullable().optional(),
  active: z.boolean().optional(),
});
